import { jsxs as o, jsx as s } from "react/jsx-runtime";
const r = (a) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "url(#instagram_colored_svg__a)",
          d: "M12 2c-2.715 0-3.056.012-4.123.06-1.064.05-1.79.218-2.427.465A4.9 4.9 0 0 0 3.68 3.678 4.9 4.9 0 0 0 2.525 5.45c-.248.636-.417 1.363-.465 2.427C2.013 8.943 2 9.284 2 12s.012 3.056.06 4.122c.05 1.065.218 1.791.465 2.427a4.9 4.9 0 0 0 1.153 1.772 4.9 4.9 0 0 0 1.771 1.154c.636.247 1.363.416 2.427.465 1.067.048 1.408.06 4.123.06s3.056-.012 4.123-.06c1.064-.05 1.792-.218 2.428-.465a4.9 4.9 0 0 0 1.77-1.154 4.9 4.9 0 0 0 1.154-1.771c.246-.637.415-1.363.465-2.428.048-1.066.06-1.406.06-4.122s-.012-3.057-.06-4.123c-.05-1.065-.219-1.792-.465-2.427a4.9 4.9 0 0 0-1.154-1.772 4.9 4.9 0 0 0-1.77-1.153c-.638-.247-1.365-.416-2.43-.465-1.067-.048-1.406-.06-4.123-.06zm-.896 1.802H12c2.67 0 2.986.01 4.04.058.975.044 1.504.207 1.857.344.466.181.8.398 1.149.748.35.35.567.683.748 1.15.137.352.3.881.345 1.856.048 1.054.058 1.371.058 4.04s-.01 2.985-.058 4.04c-.045.974-.208 1.503-.345 1.855a3.1 3.1 0 0 1-.748 1.15c-.35.35-.682.566-1.15.747-.351.138-.88.3-1.856.345-1.054.048-1.37.058-4.04.058s-2.987-.01-4.041-.058c-.975-.045-1.504-.208-1.857-.345a3.1 3.1 0 0 1-1.15-.748 3.1 3.1 0 0 1-.748-1.15c-.137-.351-.3-.88-.345-1.855-.048-1.055-.057-1.371-.057-4.042s.01-2.985.057-4.04c.045-.974.208-1.504.345-1.856.181-.467.398-.8.748-1.15s.683-.567 1.15-.748c.352-.138.882-.3 1.857-.345.922-.042 1.28-.054 3.144-.056zm6.234 1.66a1.2 1.2 0 1 0 0 2.401 1.2 1.2 0 0 0 0-2.4m-5.337 1.403a5.136 5.136 0 1 0 0 10.27 5.136 5.136 0 0 0 0-10.27m0 1.802a3.333 3.333 0 1 1 0 6.666 3.333 3.333 0 0 1 0-6.666"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "url(#instagram_colored_svg__b)",
          d: "M12 2c-2.715 0-3.056.012-4.123.06-1.064.05-1.79.218-2.427.465A4.9 4.9 0 0 0 3.68 3.678 4.9 4.9 0 0 0 2.525 5.45c-.248.636-.417 1.363-.465 2.427C2.013 8.943 2 9.284 2 12s.012 3.056.06 4.122c.05 1.065.218 1.791.465 2.427a4.9 4.9 0 0 0 1.153 1.772 4.9 4.9 0 0 0 1.771 1.154c.636.247 1.363.416 2.427.465 1.067.048 1.408.06 4.123.06s3.056-.012 4.123-.06c1.064-.05 1.792-.218 2.428-.465a4.9 4.9 0 0 0 1.77-1.154 4.9 4.9 0 0 0 1.154-1.771c.246-.637.415-1.363.465-2.428.048-1.066.06-1.406.06-4.122s-.012-3.057-.06-4.123c-.05-1.065-.219-1.792-.465-2.427a4.9 4.9 0 0 0-1.154-1.772 4.9 4.9 0 0 0-1.77-1.153c-.638-.247-1.365-.416-2.43-.465-1.067-.048-1.406-.06-4.123-.06zm-.896 1.802H12c2.67 0 2.986.01 4.04.058.975.044 1.504.207 1.857.344.466.181.8.398 1.149.748.35.35.567.683.748 1.15.137.352.3.881.345 1.856.048 1.054.058 1.371.058 4.04s-.01 2.985-.058 4.04c-.045.974-.208 1.503-.345 1.855a3.1 3.1 0 0 1-.748 1.15c-.35.35-.682.566-1.15.747-.351.138-.88.3-1.856.345-1.054.048-1.37.058-4.04.058s-2.987-.01-4.041-.058c-.975-.045-1.504-.208-1.857-.345a3.1 3.1 0 0 1-1.15-.748 3.1 3.1 0 0 1-.748-1.15c-.137-.351-.3-.88-.345-1.855-.048-1.055-.057-1.371-.057-4.042s.01-2.985.057-4.04c.045-.974.208-1.504.345-1.856.181-.467.398-.8.748-1.15s.683-.567 1.15-.748c.352-.138.882-.3 1.857-.345.922-.042 1.28-.054 3.144-.056zm6.234 1.66a1.2 1.2 0 1 0 0 2.401 1.2 1.2 0 0 0 0-2.4m-5.337 1.403a5.136 5.136 0 1 0 0 10.27 5.136 5.136 0 0 0 0-10.27m0 1.802a3.333 3.333 0 1 1 0 6.666 3.333 3.333 0 0 1 0-6.666"
        }
      ),
      /* @__PURE__ */ o("defs", { children: [
        /* @__PURE__ */ o(
          "radialGradient",
          {
            id: "instagram_colored_svg__a",
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "matrix(0 -19.8215 18.4348 0 7.312 23.54)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ s("stop", { stopColor: "#FD5" }),
              /* @__PURE__ */ s("stop", { offset: 0.1, stopColor: "#FD5" }),
              /* @__PURE__ */ s("stop", { offset: 0.5, stopColor: "#FF543E" }),
              /* @__PURE__ */ s("stop", { offset: 1, stopColor: "#C837AB" })
            ]
          }
        ),
        /* @__PURE__ */ o(
          "radialGradient",
          {
            id: "instagram_colored_svg__b",
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "matrix(1.739 8.68794 -35.81067 7.16796 -1.35 3.44)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ s("stop", { stopColor: "#3771C8" }),
              /* @__PURE__ */ s("stop", { offset: 0.128, stopColor: "#3771C8" }),
              /* @__PURE__ */ s("stop", { offset: 1, stopColor: "#60F", stopOpacity: 0 })
            ]
          }
        )
      ] })
    ]
  }
);
export {
  r as default
};
